import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

//
// Library Model/Services
//
import { Response } from '../../../../lib/angular/model/common/response';
import { Vehicle } from '../../../../lib/angular/model/vehicle/vehicle';
import { RtiHttpService } from '../../../../lib/angular/service/rti-HttpService';
//
// App Service(s)
//
import { ddHttpService } from '../dd-HttpService';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';

@Injectable()
export class ddMarketplaceInventoryService extends ddHttpService {
  //
  // Rest API Endpoint
  //
  static readonly GET_API: string = 'marketplace-inventory/vehicles';

  /**
   * get()
   */
  public get(params?: object): Observable<Response<Vehicle>> {
    return super._get<Vehicle>(ddMarketplaceInventoryService.GET_API, this._map, params);
  }

  /**
   * getByVin()
   */
  public getByVin(vin: string, params?: object): Observable<Response<Vehicle>> {
    const url = `${ddMarketplaceInventoryService.GET_API}/${vin}`;
    return super._get<Vehicle>(url, this._map, params);
  }

  /**
   * put()
   */
  public put(id: string, model: Vehicle): Observable<Response<Vehicle>> {
    return super._put<Vehicle>(ddMarketplaceInventoryService.GET_API, model, id, this._map);
  }

  /**
   * post()
   */
  public post(model: any): Observable<Response<Vehicle>> {
    return super._post<Vehicle>(ddMarketplaceInventoryService.GET_API, model, this._map);
  }

  /**
   * patch()
   */
  public patch(model: any): Observable<Response<Vehicle>> {
    return super._patch<Vehicle>(ddMarketplaceInventoryService.GET_API, model, this._map);
  }

  /**
   * delete()
   */
  public delete(id: any): Observable<Response<Vehicle>> {
    return super._delete<Vehicle>(ddMarketplaceInventoryService.GET_API, {id}, this._map);
  }

  /**
   * _map()
   */
  private _map(item: any): Vehicle {
    return new Vehicle(item);
  }

  /**
   * Function: constructor()
   */
  constructor(http: RtiHttpService,
              environment: EnvironmentConfiguration) {
    super(http, environment);
  }
}
